import store from '@/store'
import { ref, computed } from '@vue/composition-api'
import { getData } from '@core/utils/http/general'

export const configTableAlumnosBajas = () => {
  const userRol = computed(() => store.state.cuenta.rolSelected) //* Return current role
  const matricula = computed(() => store.state.cuenta.info.matricula) //* Return current role
  const nombres = Object

  if (userRol.value.id === 1) {
    nombres.habilitar = 'd-none '
    nombres.keyn = ''
    nombres.habilitarna = 'd-none '
    nombres.keyna = ''
    nombres.habilitarm = 'd-none '
    nombres.keym = ''
  } else {
    nombres.habilitar = ''
    nombres.keyn = 'editar'
    nombres.habilitarna = ''
    nombres.keyna = 'nombre'
    nombres.habilitarm = ''
    nombres.keym = 'matricula'
  }
  const tableColumns = [
    { key: 'tipo_baja', label: 'Tipo de Baja', sortable: true },
    { key: 'tipo_solicitante', label: 'Solicitante', sortable: true },
    {
      key: nombres.keym, label: 'Matricula', sortable: false, tdClass: nombres.habilitarm,
    },
    {
      key: nombres.keyna, label: 'Nombre', sortable: false, tdClass: nombres.habilitarna,
    },
    { key: 'clave', label: 'periodo', sortable: true },
    { key: 'fecha_solicitud', label: 'fecha solicitud', sortable: false },
    { key: 'opciones', label: 'ver', sortable: false },
    {
      key: nombres.keyn, label: 'Editar', sortable: false, tdClass: nombres.habilitar,
    },
    { key: 'resolucion', label: 'resolución', sortable: false },
    { key: 'justificacion_res', label: 'motivo', sortable: false },
    { key: 'fecha_resolucion', label: 'fecha resolución', sortable: false },
  ]
  const tableColumnsBA = [
    {
      key: 'matricula', label: 'Matricula', sortable: true,
    },
    {
      key: 'nombre', label: 'Nombre', sortable: true,
    },
    { key: 'clave', label: 'Último Periodo', sortable: true },
    { key: 'opciones', label: 'Kardex', sortable: false },
    {
      key: nombres.keyn, label: 'Re-Inscribir', sortable: false,
    },
  ]
  const configRequest = ref({
    wsParams: {
      action: 7, token: store.state.cuenta.session.token, data: matricula, u: userRol.value.id,
    }, //* Request params
    wsType: 'wsbajas', //* WebService name
    filterGetter: 'bajas/filterAlumnosB', //* Getter function to filter data
  })
  const configRequestA = ref({
    wsParams: {
      action: 13, token: store.state.cuenta.session.token,
    }, //* Request params
    wsType: 'wsbajas', //* WebService name
    filterGetter: 'bajas/filterAlumnosB', //* Getter function to filter data
  })
  // *--------- UI --------*
  const resolveTipoBajaVariant = nombre => {
    if (nombre === 'BT') return 'info'
    if (nombre === 'BD') return 'danger'
    if (nombre === 'BA') return 'warning'
    return 'primary'
  }
  const resolveTipoNombre = nombre => {
    if (nombre === 'BT') return 'Temporal'
    if (nombre === 'BD') return 'Definitiva'
    if (nombre === 'BA') return 'Académica'
    return 'Desconocido'
  }
  const resolveTipoEstado = nombre => {
    if (nombre === 1) return 'success'
    if (nombre === 0) return 'danger'
    if (nombre === null) return 'warning'
    return 'danger'
  }
  const resolveEstadoNombre = nombre => {
    if (nombre === 1) return 'Aprobado'
    if (nombre === 0) return 'Rechazado'
    if (nombre === null) return 'Pendiente'
    return 'Desconocido'
  }
  return {
    tableColumns,
    tableColumnsBA,
    configRequest,
    configRequestA,
    resolveTipoBajaVariant,
    resolveTipoNombre,
    resolveTipoEstado,
    resolveEstadoNombre,
  }
}

export const useBajasMateriasA = dato => {
  const materias = ref([])

  const materiasPromise = new Promise((resolve, reject) => {
    getData({ action: 9, token: store.state.cuenta.session.token, data: dato }, 'wsbajas')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          materias.value = response.data.data
          resolve()
        } else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  return {
    materias,
    materiasPromise,

  }
}
export const useBajasDetalle = dato => {
  const detalle = ref([])
  const detallePromise = new Promise((resolve, reject) => {
    getData({ action: 10, token: store.state.cuenta.session.token, data: dato }, 'wsbajas')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          detalle.value = response.data.data
          resolve(response.data.data)
        } else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  return {
    detalle,
    detallePromise,
  }
}
export const bajaAlumno = dato => {
  const alumnoBajaPromise = new Promise((resolve, reject) => {
    getData({ action: 15, token: store.state.cuenta.session.token, data: dato }, 'wsbajas')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          resolve(response.data.data)
        } else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })
  return {
    alumnoBajaPromise,
  }
}
